/*
 * Changed text from "Choose Options" to "View Collection"
 */

import { Linkable } from '@/components/blocks/Linkable';
import { productCardActionIconButtonProps } from '@/components/blocks/ProductCard/styles/actionIconButtonProps';
import { productCardInventoryStack } from '@/components/blocks/ProductCard/styles/inventoryStack';
import { useLocalization } from '@/data/Localization';
import { TYPES } from '@/data/constants/product';
import { ContentContext } from '@/data/context/content';
import { ProductCardContextValue } from '@/data/types/ProductCard';
import { productIsA } from '@/utils/productIsA';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import { Stack } from '@mui/material';
import { FC, useContext } from 'react';

export const ProductCardChooseOptions: FC<{
	onClickProduct?: () => void;
}> = ({ onClickProduct }) => {
	const productDetail = useLocalization('productDetail');
	const { routeUrl, product } = useContext(ContentContext) as ProductCardContextValue;

	return (
		<Stack {...productCardInventoryStack}>
			{product && productIsA(product, TYPES.bundle) ? (
				<Linkable
					{...productCardActionIconButtonProps}
					href={routeUrl}
					type="button"
					onClick={onClickProduct}
				>
					<Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
						<DashboardCustomizeIcon />
						<span>{productDetail.ViewCollection.t()}</span>
					</Stack>
				</Linkable>
			) : null}
		</Stack>
	);
};
